import React from 'react'
import axios from 'axios'
import debounce from 'debounce-fn'
import isEqual from 'react-fast-compare'

const DEFAULT_DEBOUNCE_WAIT = 500

class AxiosFetcher extends React.Component {
  state = {
    data: undefined,
    loading: false,
    error: false,
    errorStatus: undefined,
    errorBody: undefined,
  }

  cancelToken = null

  componentDidMount() {
    this.fetchData()
  }

  componentDidUpdate({children: _, ...prevProps}) {
    const {children, ...props} = this.props
    if (!isEqual(prevProps, props)) {
      this.fetchData()
    }
  }

  componentWillUnmount() {
    if (this.cancelToken) {
      this.cancelToken()
    }
  }

  makeNetworkRequest = debounce(() => {
    const {url, method = 'get', params, data} = this.props

    axios({
      url,
      method,
      params,
      data,
      headers: {'X-Requested-With': 'XMLHttpRequest'},
      cancelToken: new axios.CancelToken(token => {
        this.cancelToken = token
      }),
    })
      .then(res => {
        this.cancelToken = null
        this.setState({
          data: res.data,
          loading: false,
          error: false,
          errorStatus: undefined,
          errorBody: undefined,
        })
      })
      .catch(e => {
        if (axios.isCancel(e)) {
          return
        }
        this.setState({
          data: undefined,
          error: e.message,
          errorStatus: e.response && e.response.status,
          errorBody: e.response && e.response.data,
          loading: false,
        })
        console.error(e)
      })
    // A trailing-edge debounce only collapses calls closer together than `wait`, so
    // this figure decides how many requests a typed search costs: at 500ms, anyone
    // typing slower than that pays one request per character. Callers whose input is
    // a text field should raise it.
  }, { wait: this.props.debounceWait || DEFAULT_DEBOUNCE_WAIT })

  fetchData = () => {
    if (this.cancelToken) {
      this.cancelToken()
    }

    this.setState({error: false, errorStatus: undefined, errorBody: undefined, loading: true})

    this.makeNetworkRequest()
  }

  render() {
    const {children} = this.props
    const {data, loading, error, errorStatus, errorBody} = this.state

    return children({
      data,
      loading,
      error,
      errorStatus,
      errorBody,
      refetch: this.fetchData,
    })
  }
}

export default AxiosFetcher
